var _rect, _text, _circle, _circle2, _circle3, _text2, _rect2, _text3, _rect3, _text4, _rect4, _text5, _rect5, _text6, _path, _rect6, _circle4, _text7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomDevelopmentResponsibleAiGovernanceModelDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 720,
    height: 460,
    viewBox: "0 0 720 460",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Responsible AI governance model") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 718,
    height: 458,
    rx: 27,
    fill: "#020B1B",
    stroke: "#2B5A85"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 35,
    y: 42,
    fill: "#74BDFF",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 850,
    letterSpacing: 1.4
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 35,
    dy: 0
  }, "GOVERNANCE MODEL"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 359,
    cy: 214,
    r: 152,
    fill: "#07162B",
    stroke: "#2B5A85"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 359,
    cy: 214,
    r: 112,
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 359,
    cy: 214,
    r: 73,
    fill: "#0B2340",
    stroke: "#FF2775",
    strokeWidth: 2
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 359,
    y: 201,
    fill: "#FFFFFF",
    textAnchor: "middle",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 17,
    fontWeight: 850,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 359,
    dy: 0
  }, "HUMAN-OWNED"), /*#__PURE__*/React.createElement("tspan", {
    x: 359,
    dy: 21
  }, "DECISION"))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 89,
    width: 168,
    height: 80,
    rx: 15,
    fill: "#0A1C34",
    stroke: "#087CFF"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 54,
    y: 120,
    fill: "#FFFFFF",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 11,
    fontWeight: 800,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 54,
    dy: 0
  }, "AUDITABLE"), /*#__PURE__*/React.createElement("tspan", {
    x: 54,
    dy: 20
  }, "Evidence and history"))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 516,
    y: 89,
    width: 168,
    height: 80,
    rx: 15,
    fill: "#0A1C34",
    stroke: "#FF2775"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 536,
    y: 120,
    fill: "#FFFFFF",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 11,
    fontWeight: 800,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 536,
    dy: 0
  }, "REVIEWABLE"), /*#__PURE__*/React.createElement("tspan", {
    x: 536,
    dy: 20
  }, "Human intervention"))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 259,
    width: 168,
    height: 80,
    rx: 15,
    fill: "#0A1C34",
    stroke: "#30D6A1"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 54,
    y: 290,
    fill: "#FFFFFF",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 11,
    fontWeight: 800,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 54,
    dy: 0
  }, "CONTROLLED"), /*#__PURE__*/React.createElement("tspan", {
    x: 54,
    dy: 20
  }, "Access and privacy"))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 516,
    y: 259,
    width: 168,
    height: 80,
    rx: 15,
    fill: "#0A1C34",
    stroke: "#F4B63D"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 536,
    y: 290,
    fill: "#FFFFFF",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 11,
    fontWeight: 800,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 536,
    dy: 0
  }, "MONITORED"), /*#__PURE__*/React.createElement("tspan", {
    x: 536,
    dy: 20
  }, "Quality and drift"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M202 129h65M451 129h65M202 299h65M451 299h65",
    stroke: "#4A9BE4",
    strokeWidth: 2,
    strokeDasharray: "4 6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 382,
    width: 650,
    height: 42,
    rx: 13,
    fill: "#10243E"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 403,
    r: 5,
    fill: "#30D6A1"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 73,
    y: 407,
    fill: "#FFFFFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 800
  }, "AI SUPPORTS THE DECISION \xB7 PEOPLE RETAIN RESPONSIBILITY")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomDevelopmentResponsibleAiGovernanceModelDesktop);
export default __webpack_public_path__ + "static/media/custom-development-responsible-ai-governance-model-desktop.f2264a3e395525f401704bef7e016208.svg";
export { ForwardRef as ReactComponent };